// extracted by mini-css-extract-plugin
module.exports = {"card":"c_c","flex":"c_d"};